module.exports = __webpack_public_path__ + "static/img/bot.c64531e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobel/bot.png
// module id = cFlm
// module chunks = 1